import React, { useState } from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

const services = [
  { icon: '✈', title: 'Corporate Flight Booking', desc: 'Best corporate fares on all domestic and international routes with priority booking.' },
  { icon: '🏨', title: 'Corporate Hotel Booking', desc: 'Preferred hotel rates with GST-compliant invoicing at 5000+ properties across India.' },
  { icon: '💼', title: 'Business Travel Management', desc: 'End-to-end travel policy management, cost controls and reporting.' },
  { icon: '👔', title: 'Executive Travel', desc: 'Premium business class, lounge access and concierge services for senior leadership.' },
  { icon: '👥', title: 'Group Travel', desc: 'Seamless logistics for conferences, offsites, team events and group bookings.' },
  { icon: '🌍', title: 'International Business Travel', desc: 'Visa support, global hotels and business flights for international assignments.' },
  { icon: '🛂', title: 'Corporate Visa Assistance', desc: 'Fast-track business visa processing for employee travel worldwide.' },
  { icon: '📋', title: 'Travel Policy Management', desc: "Custom travel policy setup aligned with your company's compliance requirements." },
  { icon: '🖥', title: 'Dedicated Travel Desk', desc: 'A named travel consultant available during business hours for your company.' },
  { icon: '🆘', title: '24/7 Travel Support', desc: 'Emergency travel support for employees — any hour, any destination.' },
];

const dashboardStats = [
  { label: 'Upcoming Trips', value: '14', delta: '+3 this week', color: 'var(--royal, #0D47A1)' },
  { label: 'Monthly Travel Spend', value: '₹8.4L', delta: '−12% vs last month', color: 'var(--success, #16865B)' },
  { label: 'Pending Approvals', value: '5', delta: '2 urgent', color: 'var(--gold, #C9A45C)' },
  { label: 'Active Travellers', value: '9', delta: 'As of today', color: 'var(--navy, #071A2B)' },
];

const bookings = [
  { emp: 'Rahul Menon', dept: 'Sales', from: 'HYD', to: 'DEL', date: '28 Aug', status: 'Confirmed', class: 'Business' },
  { emp: 'Anita Reddy', dept: 'Finance', from: 'BOM', to: 'BLR', date: '29 Aug', status: 'Pending Approval', class: 'Economy' },
  { emp: 'Suresh Kumar', dept: 'Tech', from: 'BLR', to: 'MAA', date: '30 Aug', status: 'Confirmed', class: 'Economy' },
  { emp: 'Priya Nair', dept: 'HR', from: 'DEL', to: 'CCU', date: '01 Sep', status: 'Confirmed', class: 'Economy' },
  { emp: 'Vikram Shah', dept: 'Sales', from: 'HYD', to: 'BOM', date: '03 Sep', status: 'Pending Approval', class: 'Business' },
];

const sidebarItems = [
  { icon: '▦', label: 'Dashboard', active: true },
  { icon: '📋', label: 'Bookings' },
  { icon: '👤', label: 'Travellers' },
  { icon: '✓', label: 'Approvals', badge: 5 },
  { icon: '🧾', label: 'Invoices' },
  { icon: '📊', label: 'Reports' },
  { icon: '📑', label: 'Travel Policy' },
  { icon: '🆘', label: 'Support' },
  { icon: '🏢', label: 'Company Profile' },
];

export default function Corporate() {
  const [view, setView] = useState('landing');

  return (
    <>
      <Nav />
      <div style={{ minHeight: '100vh', background: 'var(--bg, #f8fafc)' }}>
        {view === 'landing' ? (
          <>
            {/* Hero */}
            <div
              style={{
                background: 'var(--navy, #071A2B)',
                paddingTop: '80px',
                paddingBottom: '64px',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background:
                    'radial-gradient(ellipse at 80% 50%, rgba(13,71,161,0.4) 0%, transparent 70%)',
                }}
              />
              <div
                style={{
                  position: 'relative',
                  zIndex: 10,
                  maxWidth: '1280px',
                  margin: '0 auto',
                  padding: '32px 24px',
                }}
              >
                <div style={{ maxWidth: '672px' }}>
                  <p
                    style={{
                      textTransform: 'uppercase',
                      letterSpacing: '0.1em',
                      fontSize: '12px',
                      fontWeight: 700,
                      color: 'var(--gold, #C9A45C)',
                      marginBottom: '12px',
                    }}
                  >
                    Corporate Travel
                  </p>
                  <h1
                    style={{
                      fontSize: '44px',
                      fontWeight: 800,
                      color: '#ffffff',
                      marginBottom: '20px',
                      lineHeight: 1.1,
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    Corporate Travel,
                    <br />
                    <span style={{ color: 'var(--gold, #C9A45C)' }}>
                      Handled Seamlessly.
                    </span>
                  </h1>
                  <p
                    style={{
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: '16px',
                      marginBottom: '32px',
                      lineHeight: '1.6',
                    }}
                  >
                    Reliable travel management for businesses across India. Policy-aligned,
                    cost-controlled, and always supported.
                  </p>
                  <div style={{ display: 'flex', gap: '12px' }}>
                    <button
                      onClick={() => setView('dashboard')}
                      style={{
                        padding: '14px 28px',
                        borderRadius: '12px',
                        fontSize: '15px',
                        fontWeight: 700,
                        background: 'var(--gold, #C9A45C)',
                        color: 'var(--navy, #071A2B)',
                        border: 'none',
                        cursor: 'pointer',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    >
                      View Dashboard Demo
                    </button>
                    <button
                      style={{
                        padding: '14px 28px',
                        borderRadius: '12px',
                        fontSize: '15px',
                        fontWeight: 600,
                        color: '#ffffff',
                        border: '1.5px solid rgba(255,255,255,0.3)',
                        fontFamily: 'Manrope, sans-serif',
                        background: 'rgba(255,255,255,0.06)',
                        cursor: 'pointer',
                      }}
                    >
                      Request Consultation
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Services */}
            <div
              style={{
                maxWidth: '1280px',
                margin: '0 auto',
                padding: '64px 24px',
                boxSizing: 'border-box',
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <p
                  style={{
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    fontSize: '12px',
                    fontWeight: 700,
                    color: 'var(--gold, #C9A45C)',
                    marginBottom: '12px',
                  }}
                >
                  What We Offer
                </p>
                <h2
                  style={{
                    fontSize: '30px',
                    fontWeight: 800,
                    fontFamily: 'Manrope, sans-serif',
                    color: 'var(--navy, #071A2B)',
                    margin: 0,
                  }}
                >
                  Complete Corporate Travel Management
                </h2>
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                  gap: '16px',
                  marginBottom: '56px',
                }}
              >
                {services.map((s) => (
                  <div
                    key={s.title}
                    style={{
                      padding: '16px',
                      borderRadius: '12px',
                      background: 'var(--white, #ffffff)',
                      border: '1px solid var(--border, #e2e8f0)',
                      boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '24px',
                        display: 'block',
                        marginBottom: '12px',
                      }}
                    >
                      {s.icon}
                    </span>
                    <p
                      style={{
                        fontWeight: 700,
                        fontSize: '13px',
                        marginBottom: '6px',
                        fontFamily: 'Manrope, sans-serif',
                        color: 'var(--navy, #071A2B)',
                      }}
                    >
                      {s.title}
                    </p>
                    <p
                      style={{
                        fontSize: '12px',
                        lineHeight: '1.6',
                        color: 'var(--text-secondary, #475569)',
                        margin: 0,
                      }}
                    >
                      {s.desc}
                    </p>
                  </div>
                ))}
              </div>

              {/* Approval Flow */}
              <div
                style={{
                  borderRadius: '16px',
                  padding: '32px',
                  marginBottom: '40px',
                  background: 'var(--navy, #071A2B)',
                  border: '1px solid rgba(201,164,92,0.15)',
                }}
              >
                <p
                  style={{
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    fontSize: '12px',
                    fontWeight: 700,
                    color: 'var(--gold, #C9A45C)',
                    marginBottom: '12px',
                  }}
                >
                  How It Works
                </p>
                <h3
                  style={{
                    fontSize: '24px',
                    fontWeight: 700,
                    color: '#ffffff',
                    marginBottom: '32px',
                    fontFamily: 'Manrope, sans-serif',
                  }}
                >
                  Approval Flow
                </h3>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '12px',
                  }}
                >
                  {[
                    { step: '1', label: 'Employee Request' },
                    { step: '→', label: '' },
                    { step: '2', label: 'Manager Approval' },
                    { step: '→', label: '' },
                    { step: '3', label: 'Travel Desk' },
                    { step: '→', label: '' },
                    { step: '4', label: 'Booking' },
                    { step: '→', label: '' },
                    { step: '5', label: 'GST Invoice' },
                  ].map((item, i) =>
                    item.step === '→' ? (
                      <span
                        key={i}
                        style={{ color: 'rgba(255,255,255,0.3)', fontSize: '20px' }}
                      >
                        →
                      </span>
                    ) : (
                      <div key={i} style={{ textAlign: 'center' }}>
                        <div
                          style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '18px',
                            fontWeight: 800,
                            marginBottom: '8px',
                            margin: '0 auto 8px auto',
                            background: 'rgba(201,164,92,0.15)',
                            color: 'var(--gold, #C9A45C)',
                            border: '1px solid rgba(201,164,92,0.3)',
                            fontFamily: 'Manrope, sans-serif',
                          }}
                        >
                          {item.step}
                        </div>
                        <p
                          style={{
                            fontSize: '12px',
                            color: 'rgba(255,255,255,0.6)',
                            margin: 0,
                          }}
                        >
                          {item.label}
                        </p>
                      </div>
                    )
                  )}
                </div>
              </div>

              {/* Consultation CTA */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                  gap: '20px',
                }}
              >
                {[
                  {
                    title: 'Request Corporate Consultation',
                    desc: "Talk to our corporate travel team about your company's specific needs.",
                    cta: 'Book Consultation',
                    style: 'gold',
                  },
                  {
                    title: 'Talk to Corporate Travel Expert',
                    desc: 'Have an urgent requirement? Call us directly during business hours.',
                    cta: '+91 98765 43210',
                    style: 'outline',
                  },
                ].map((card) => (
                  <div
                    key={card.title}
                    style={{
                      borderRadius: '12px',
                      padding: '24px',
                      background: 'var(--white, #ffffff)',
                      border: '1px solid var(--border, #e2e8f0)',
                      boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: 700,
                        fontSize: '16px',
                        marginBottom: '8px',
                        fontFamily: 'Manrope, sans-serif',
                        color: 'var(--navy, #071A2B)',
                      }}
                    >
                      {card.title}
                    </h3>
                    <p
                      style={{
                        fontSize: '13px',
                        marginBottom: '16px',
                        color: 'var(--text-secondary, #475569)',
                      }}
                    >
                      {card.desc}
                    </p>
                    <button
                      style={{
                        padding: '10px 24px',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: 700,
                        cursor: 'pointer',
                        fontFamily: 'Manrope, sans-serif',
                        border:
                          card.style === 'gold'
                            ? 'none'
                            : '1.5px solid var(--navy, #071A2B)',
                        background:
                          card.style === 'gold'
                            ? 'var(--gold, #C9A45C)'
                            : 'transparent',
                        color: 'var(--navy, #071A2B)',
                      }}
                    >
                      {card.cta}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          /* Dashboard View */
          <div style={{ display: 'flex', paddingTop: '64px' }}>
            {/* Sidebar */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '208px',
                minHeight: '100vh',
                paddingTop: '24px',
                paddingLeft: '12px',
                paddingRight: '12px',
                background: 'var(--white, #ffffff)',
                borderRight: '1px solid var(--border, #e2e8f0)',
                position: 'sticky',
                top: 0,
                height: '100vh',
                overflowY: 'auto',
                boxSizing: 'border-box',
              }}
            >
              <div style={{ padding: '0 12px', marginBottom: '24px' }}>
                <p
                  style={{
                    fontSize: '11px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    marginBottom: '2px',
                    color: 'var(--text-muted, #64748b)',
                    fontFamily: 'Manrope, sans-serif',
                  }}
                >
                  Company
                </p>
                <p
                  style={{
                    fontWeight: 700,
                    fontSize: '13px',
                    color: 'var(--navy, #071A2B)',
                    fontFamily: 'Manrope, sans-serif',
                    margin: 0,
                  }}
                >
                  Nexion Technologies
                </p>
                <p
                  style={{
                    fontSize: '11px',
                    color: 'var(--text-muted, #64748b)',
                    margin: '2px 0 0 0',
                  }}
                >
                  GST: 36AAPCA1234A1ZX
                </p>
              </div>
              {sidebarItems.map((item) => (
                <button
                  key={item.label}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    marginBottom: '4px',
                    textAlign: 'left',
                    fontSize: '13px',
                    border: 'none',
                    cursor: 'pointer',
                    background: item.active
                      ? 'rgba(7,26,43,0.07)'
                      : 'transparent',
                    color: item.active
                      ? 'var(--navy, #071A2B)'
                      : 'var(--text-secondary, #475569)',
                    fontFamily: 'Manrope, sans-serif',
                    fontWeight: item.active ? 700 : 500,
                  }}
                >
                  <span style={{ fontSize: '14px' }}>{item.icon}</span>
                  {item.label}
                  {item.badge && (
                    <span
                      style={{
                        marginLeft: 'auto',
                        fontSize: '10px',
                        fontWeight: 700,
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'var(--error, #ef4444)',
                        color: 'white',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    >
                      {item.badge}
                    </span>
                  )}
                </button>
              ))}
              <div style={{ marginTop: 'auto', paddingBottom: '16px' }}>
                <button
                  onClick={() => setView('landing')}
                  style={{
                    width: '100%',
                    textAlign: 'left',
                    padding: '10px 12px',
                    fontSize: '12px',
                    borderRadius: '8px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: 'var(--text-muted, #64748b)',
                    fontFamily: 'Manrope, sans-serif',
                  }}
                >
                  ← Back to Corporate
                </button>
              </div>
            </div>

            {/* Main Dashboard Panel */}
            <div style={{ flex: 1, padding: '24px', overflowX: 'auto' }}>
              <div style={{ maxWidth: '896px' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '24px',
                  }}
                >
                  <div>
                    <h2
                      style={{
                        fontSize: '24px',
                        fontWeight: 800,
                        fontFamily: 'Manrope, sans-serif',
                        color: 'var(--navy, #071A2B)',
                        margin: 0,
                      }}
                    >
                      Corporate Dashboard
                    </h2>
                    <p
                      style={{
                        fontSize: '13px',
                        marginTop: '2px',
                        color: 'var(--text-muted, #64748b)',
                      }}
                    >
                      August 2026
                    </p>
                  </div>
                  <button
                    style={{
                      padding: '10px 20px',
                      borderRadius: '12px',
                      fontSize: '13px',
                      fontWeight: 700,
                      background: 'var(--gold, #C9A45C)',
                      color: 'var(--navy, #071A2B)',
                      border: 'none',
                      cursor: 'pointer',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    + New Booking
                  </button>
                </div>

                {/* Stat Cards */}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                    gap: '16px',
                    marginBottom: '24px',
                  }}
                >
                  {dashboardStats.map((stat) => (
                    <div
                      key={stat.label}
                      style={{
                        borderRadius: '12px',
                        padding: '16px',
                        background: 'var(--white, #ffffff)',
                        border: '1px solid var(--border, #e2e8f0)',
                        boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                      }}
                    >
                      <p
                        style={{
                          fontSize: '11px',
                          fontWeight: 700,
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          marginBottom: '8px',
                          color: 'var(--text-muted, #64748b)',
                          fontFamily: 'Manrope, sans-serif',
                        }}
                      >
                        {stat.label}
                      </p>
                      <p
                        style={{
                          fontSize: '24px',
                          fontWeight: 800,
                          marginBottom: '4px',
                          fontFamily: 'Manrope, sans-serif',
                          color: 'var(--navy, #071A2B)',
                          margin: '0 0 4px 0',
                        }}
                      >
                        {stat.value}
                      </p>
                      <p
                        style={{
                          fontSize: '11px',
                          color: stat.color,
                          fontFamily: 'Manrope, sans-serif',
                          margin: 0,
                        }}
                      >
                        {stat.delta}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Upcoming Bookings Table */}
                <div
                  style={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    background: 'var(--white, #ffffff)',
                    border: '1px solid var(--border, #e2e8f0)',
                    boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '16px 20px',
                      borderBottom: '1px solid var(--border, #e2e8f0)',
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: 700,
                        fontSize: '15px',
                        fontFamily: 'Manrope, sans-serif',
                        color: 'var(--navy, #071A2B)',
                        margin: 0,
                      }}
                    >
                      Upcoming Trips
                    </h3>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 600,
                        color: 'var(--royal, #0D47A1)',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    >
                      View All Bookings
                    </button>
                  </div>
                  <table
                    style={{
                      width: '100%',
                      fontSize: '13px',
                      borderCollapse: 'collapse',
                    }}
                  >
                    <thead>
                      <tr style={{ background: 'var(--bg, #f8fafc)' }}>
                        {[
                          'Employee',
                          'Department',
                          'Route',
                          'Date',
                          'Class',
                          'Status',
                        ].map((h) => (
                          <th
                            key={h}
                            style={{
                              textAlign: 'left',
                              padding: '12px 20px',
                              fontSize: '11px',
                              fontWeight: 700,
                              textTransform: 'uppercase',
                              letterSpacing: '0.05em',
                              color: 'var(--text-muted, #64748b)',
                              fontFamily: 'Manrope, sans-serif',
                            }}
                          >
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {bookings.map((b, i) => (
                        <tr
                          key={i}
                          style={{
                            borderBottom: '1px solid var(--border, #e2e8f0)',
                          }}
                        >
                          <td
                            style={{
                              padding: '12px 20px',
                              fontWeight: 600,
                              color: 'var(--navy, #071A2B)',
                              fontFamily: 'Manrope, sans-serif',
                            }}
                          >
                            {b.emp}
                          </td>
                          <td
                            style={{
                              padding: '12px 20px',
                              color: 'var(--text-secondary, #475569)',
                            }}
                          >
                            {b.dept}
                          </td>
                          <td
                            style={{
                              padding: '12px 20px',
                              fontWeight: 500,
                              color: 'var(--navy, #071A2B)',
                              fontFamily: 'Manrope, sans-serif',
                            }}
                          >
                            {b.from} → {b.to}
                          </td>
                          <td
                            style={{
                              padding: '12px 20px',
                              color: 'var(--text-secondary, #475569)',
                            }}
                          >
                            {b.date} Aug
                          </td>
                          <td
                            style={{
                              padding: '12px 20px',
                              color: 'var(--text-secondary, #475569)',
                            }}
                          >
                            {b.class}
                          </td>
                          <td style={{ padding: '12px 20px' }}>
                            <span
                              style={{
                                fontSize: '11px',
                                fontWeight: 700,
                                padding: '4px 10px',
                                borderRadius: '9999px',
                                background:
                                  b.status === 'Confirmed'
                                    ? 'rgba(22,134,91,0.1)'
                                    : 'rgba(201,164,92,0.15)',
                                color:
                                  b.status === 'Confirmed'
                                    ? 'var(--success, #16865B)'
                                    : 'var(--gold-dark, #9C782E)',
                                fontFamily: 'Manrope, sans-serif',
                              }}
                            >
                              {b.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}